import type { MessageKey } from "./ru"

export const roMessages = {
  "common.loading": "Se încarcă...",
  "common.error": "Eroare",
  "common.back": "Înapoi",
  "common.next": "Înainte",
  "common.search": "Caută",
  "auth.loginErrorTitle": "Eroare de autentificare",
  "auth.openViaTelegram": "Deschide aplicația prin Telegram",
  "auth.telegramRequired": "Aplicația trebuie deschisă prin Telegram",
  "auth.authorizationError": "Eroare de autorizare",
  "device.rotatePortrait": "Rotește dispozitivul în modul portret",
  "country.brazil": "Brazilia",
  "country.vietnam": "Vietnam",
  "country.egypt": "Egipt",
  "country.india": "India",
  "country.indonesia": "Indonezia",
  "country.iran": "Iran",
  "country.spain": "Spania",
  "country.italy": "Italia",
  "country.kazakhstan": "Kazahstan",
  "country.colombia": "Columbia",
  "country.malaysia": "Malaezia",
  "country.mexico": "Mexic",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Rusia",
  "country.usa": "Statele Unite",
  "country.turkey": "Turcia",
  "country.uzbekistan": "Uzbekistan",
  "country.ukraine": "Ucraina",
  "country.philippines": "Filipine",
  "countrySelection.chooseCountry": "Alege țara",
  "countrySelection.openAria": "Alege țara",
  "languageSelection.chooseLanguage": "Alege limba",
  "commercial.direction.autotrade": "Piață auto",
  "commercial.direction.insurance": "Asigurare",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Asistență rutieră",
  "commercial.searchLabel": "Căutare BeepApp",
  "commercial.cityPlaceholder": "Introdu orașul",
  "commercial.emptyTitle": "Nicio ofertă astăzi",
  "commercial.emptyLine1": "Nu există încă parteneri BeepApp activi în orașul tău",
  "commercial.emptyLine2": "Lucrăm deja la găsirea și conectarea lor",
  "commercial.emptyLine3": "Ofertele noi vor apărea aici automat",
  "commercial.helperLine1": "Introdu orașul pentru a vedea",
  "commercial.helperLine2": "ofertele disponibile",
  "commercial.partnerPrompt": "Vrei să devii partener BeepApp?",
  "commercial.apply": "Aplică",
  "main.admin": "Admin",
  "main.garage": "Garaj",
  "main.signalSent": "Semnal trimis",
  "main.partnerInviteUnavailable": "Invitația de partener nu este disponibilă",
  "main.enterPlate": "Introdu numărul de înmatriculare",
  "main.searchError": "Eroare de căutare",
  "main.signalSendError": "Semnalul nu a putut fi trimis",
  "main.shareCardPrefix": "Fișa numărului",
  "main.shareLinkError": "Linkul nu a putut fi pregătit",
  "main.searchByPlateAria": "Caută după numărul de înmatriculare",
  "main.russianPlateAria": "Număr de înmatriculare rusesc",
  "main.plateAria": "Număr de înmatriculare",
  "main.findPlateAria": "Găsește numărul",
  "main.loadingVehicle": "Se încarcă fișa vehiculului…",
  "main.leaveSignal": "Trimite un semnal",
  "main.share": "Distribuie",
  "signalSelection.chooseType": "Alege tipul semnalului",
  "signalSelection.category.attention": "Personal",
  "signalSelection.category.road": "Rutier",
  "signalSelection.category.urgent": "Urgent",
  "signalSelection.chooseSignal": "Alege un semnal",
  "signalSelection.suggestOwn": "Propune propria variantă",
  "signalConfirmation.title": "Confirmă semnalul",
  "signalConfirmation.plateHeading": "Verifică numărul de înmatriculare",
  "signalConfirmation.signalHeading": "Verifică semnalul selectat",
  "signalConfirmation.replyTitle": "Permite răspunsul în Telegram",
  "signalConfirmation.replyBody": "Activează opțiunea pentru ca proprietarul numărului să îți poată\nscrie în Telegram. Răspunsurile sunt posibile doar dacă\nai un @username. Decizia de a răspunde\nrămâne la proprietarul numărului.",
  "signalConfirmation.consentText": "Confirm că acest semnal reflectă\no situație reală și nu este spam\nsau o sesizare falsă.",
  "signalConfirmation.warning": "După trimitere, semnalul\nnu mai poate fi modificat",
  "signalConfirmation.sending": "Se trimite…",
  "signalConfirmation.send": "Trimite",
  "partner.loadingAria": "Se încarcă",
  "partner.title": "Program de parteneriat",
  "partner.offerLine1": "Câștigă permanent 30% din toate plățile",
  "partner.offerLine2": "făcute de utilizatorii pe care îi inviți în BeepApp",
  "partner.offerLine3": "prin programul de afiliere Telegram",
  "partner.connectUnavailable": "Conectarea va fi disponibilă după configurarea programului de afiliere Telegram.",
  "partner.connectTelegram": "Conectează în Telegram",
  "partner.qrAria": "Cod QR pentru linkul de partener",
  "partner.download": "Descarcă",
  "partner.promoHeading": "Creează un cod promo personal",
  "partner.promoHelperLine1": "Codul promo activează un an suplimentar de abonament",
  "partner.promoHelperLine2": "și ajută la atragerea utilizatorilor",
  "partner.promoAria": "Cod promo",
  "partner.affiliateHeading": "Linkul tău de afiliere",
  "partner.affiliateHelper": "Salvează linkul pentru a crea un cod QR personal",
  "partner.affiliateAria": "Link de afiliere",
  "partner.qrNoteLine1": "Codul QR poate fi amplasat pe vehiculul tău,",
  "partner.qrNoteLine2": "pe rețelele sociale și în materiale publicitare",
  "partner.save": "Salvează",
  "partner.reset": "Resetează",
  "partner.resetConfirm": "Resetezi linkul de afiliere salvat? Codul promo va rămâne al tău.",
  "partner.promoFormatError": "Codul promo trebuie să conțină între 4 și 15 caractere.",
  "partner.affiliateHostError": "Sunt permise doar linkurile t.me sau telegram.me.",
  "partner.affiliatePathError": "Linkul nu conține o cale Telegram.",
  "partner.affiliateFormatError": "Link de afiliere nevalid.",
  "partner.loadError": "Eroare de încărcare",
  "partner.checkInputError": "Verifică informațiile introduse",
  "garageActivation.promoInvalid": "Codul promo nu este valid",
  "garageActivation.plateOccupied": "Acest număr este deja asociat",
  "garageActivation.activateError": "Garajul nu a putut fi activat",
  "garageEntry.loadJournalError": "Jurnalul de bord nu a putut fi încărcat",
  "garageEntry.loadStatusesError": "Statusurile nu au putut fi încărcate",
  "garageEntry.activationSuccess": "Garaj activat cu succes",
  "garageEntry.plateAttached": "Număr asociat",
  "garageEntry.attachError": "Numărul nu a putut fi asociat",
  "garageEntry.activationNote": "Activează-ți Garajul",
  "garageSheet.activationTitle": "Activarea Garajului",
  "garageSheet.plateHelper": "Introdu numărul de înmatriculare al vehiculului",
  "garageSheet.promoHelper": "Ai un cod promo?",
  "garageSheet.cleanBonusLine1": "După activare vei avea 1 oră",
  "garageSheet.cleanBonusLine2": "pentru un „Clean Start” gratuit",
  "garageSheet.activationFor": "Activare pentru",
  "garageSheet.cost": "Cost",
  "garageSheet.ownerConsentLine1": "Confirm că sunt proprietarul",
  "garageSheet.ownerConsentLine2": "vehiculului cu numărul de înmatriculare",
  "garageSheet.ownerConsentLine3": "specificat.",
  "garageSheet.processing": "Se procesează...",
  "garageSheet.attach": "Asociază",
  "garageSheet.pay": "Plătește",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Dezactivarea Garajului",
  "garageLifecycle.cleanWarningLine1": "Istoricul numărului va fi șters",
  "garageLifecycle.cleanWarningLine2": "fără posibilitatea recuperării!",
  "garageLifecycle.deactivateWarningLine1": "După dezactivare, accesul la funcțiile",
  "garageLifecycle.deactivateWarningLine2": "active ale Garajului va înceta",
  "garageLifecycle.willBeDeleted": "VA FI ȘTERS",
  "garageLifecycle.cleanRemovedLine1": "• Toate înregistrările din jurnalul de bord",
  "garageLifecycle.cleanRemovedLine2": "• Istoricul semnalelor primite",
  "garageLifecycle.cleanRemovedLine3": "• Contoarele publice de semnale",
  "garageLifecycle.cleanRemovedLine4": "  de pe fișa numărului",
  "garageLifecycle.willRemain": "VA RĂMÂNE",
  "garageLifecycle.cleanPreservedLine1": "• Asocierea numărului cu Garajul",
  "garageLifecycle.cleanPreservedLine2": "• Perioada de activare rămasă",
  "garageLifecycle.cleanPreservedLine3": "• Statusul de număr selectat",
  "garageLifecycle.cleanPreservedLine4": "• Numărul total de vizualizări ale fișei",
  "garageLifecycle.freeFirstHour": "Gratuit în prima oră",
  "garageLifecycle.willBecomeUnavailable": "VA DEVENI INDISPONIBIL",
  "garageLifecycle.deactivateRemovedLine1": "• Jurnalul de bord",
  "garageLifecycle.deactivateRemovedLine2": "• Selectarea și utilizarea statusului numărului",
  "garageLifecycle.deactivateRemovedLine3": "• Vei părăsi automat AutoClan",
  "garageLifecycle.deactivateRemovedLine4": "• Piață auto",
  "garageLifecycle.deactivateRemovedLine5": "• Asigurare",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Asistență rutieră",
  "garageLifecycle.deactivateRemovedLine8": "• Numărul va fi deconectat de la Garaj",
  "garageLifecycle.willRemainAvailable": "VA RĂMÂNE DISPONIBIL",
  "garageLifecycle.deactivatePreservedLine1": "• Însoțitor",
  "garageLifecycle.deactivatePreservedLine2": "• Dispecer",
  "garageLifecycle.deactivatePreservedLine3": "• Căutarea și vizualizarea numărului",
  "garageLifecycle.deactivatePreservedLine4": "  fișei publice a vehiculului",
  "garageLifecycle.deactivatePreservedLine5": "• Posibilitatea de a reactiva",
  "garageLifecycle.deactivatePreservedLine6": "  Garajul în orice moment",
  "garageLifecycle.cleanConsentLine1": "Confirm acordul pentru ștergerea",
  "garageLifecycle.cleanConsentLine2": "întregului istoric al acestui număr",
  "garageLifecycle.cleanConsentLine3": "fără posibilitatea recuperării.",
  "garageLifecycle.deactivateConsentLine1": "Confirm dezactivarea și",
  "garageLifecycle.deactivateConsentLine2": "încetarea accesului la toate",
  "garageLifecycle.deactivateConsentLine3": "funcțiile active ale Garajului.",
  "garageLifecycle.clean": "Șterge",
  "garageLifecycle.deactivate": "Dezactivează",
} satisfies Record<MessageKey, string>
